import React, { useId } from 'react';

/*
    Icone "gamificate": sagoma piena, contorno scuro, sfumatura dall'alto,
    riflesso bianco e ombra dura (come il pulsante rosso del gioco).
    Si usano per capitoli della guida, targhe dei titoli e avvisi.
    Nei pulsanti si usano invece le icone piatte (FlatIcon).
*/

const SHADOW = "#071648";

//gradiente verticale; con y1/y2 usa le coordinate del disegno (64x64)
const grad = (id, c1, c2, y1, y2) => (
    <linearGradient id={id} x1="0" x2="0"
        {...(y1 !== undefined ? { gradientUnits: "userSpaceOnUse", y1, y2 } : { y1: 0, y2: 1 })}>
        <stop offset="0" stopColor={c1} />
        <stop offset="1" stopColor={c2} />
    </linearGradient>
);

//ombra dura + contorno, disegnati riusando la sagoma definita in <defs>
const outline = (id, color, width = 6) => (
    <>
        <use href={"#" + id} transform="translate(0 3)" fill={SHADOW} stroke={SHADOW} strokeWidth={width} strokeLinejoin="round" opacity=".35" />
        <use href={"#" + id} fill={color} stroke={color} strokeWidth={width} strokeLinejoin="round" />
    </>
);

const fill = (id, fallback) => `url(#${id}) ${fallback}`;

const TROPHY_CUP = "M17 9h30v11c0 9.4-6.7 17-15 17s-15-7.6-15-17z";
const TROPHY_L = "M17 12H9v4c0 6.5 4.5 11 10.5 11.5l-1-5C14.5 22 13 19.5 13 16h4z";
const TROPHY_R = "M47 12h8v4c0 6.5-4.5 11-10.5 11.5l1-5C49.5 22 51 19.5 51 16h-4z";
const PENCIL = "M20 56L22.8 46.1L49 19.9L56.1 27L29.9 53.2Z";
const BOOK_COVER = "M4 17v37c9.5-3.2 19-3 28 1.5 9-4.5 18.5-4.7 28-1.5V17c-9.5-3.2-19-3-28 1.5C23 14 13.5 13.8 4 17z";
const BOOK_L = "M8 15c8-2.6 16-2.2 24 2v35c-8-4.2-16-4.6-24-2z";
const BOOK_R = "M56 15c-8-2.6-16-2.2-24 2v35c8-4.2 16-4.6 24-2z";
const TRASH_BODY = "M14 21h36l-3.2 32a4.5 4.5 0 0 1-4.5 4H21.7a4.5 4.5 0 0 1-4.5-4z";

const ICONS = {
    trophy: (u) => (
        <>
            <defs>
                {grad(u + "g", "#FFE780", "#F59F00", 9, 44)}
                {grad(u + "b", "#D07A1C", "#7E3600", 43, 56)}
                <g id={u + "s"}>
                    <path d={TROPHY_CUP} /><path d={TROPHY_L} /><path d={TROPHY_R} />
                    <rect x="28" y="35" width="8" height="9" />
                    <rect x="21" y="43" width="22" height="6" rx="2" />
                    <rect x="17" y="48" width="30" height="8" rx="3" />
                </g>
            </defs>
            {outline(u + "s", "#7A3A00")}
            <path d={TROPHY_L} fill={fill(u + "g", "#FFC21A")} />
            <path d={TROPHY_R} fill={fill(u + "g", "#FFC21A")} />
            <rect x="28" y="35" width="8" height="9" fill="#E08A00" />
            <path d={TROPHY_CUP} fill={fill(u + "g", "#FFC21A")} />
            <rect x="21" y="43" width="22" height="6" rx="2" fill={fill(u + "b", "#A85410")} />
            <rect x="17" y="48" width="30" height="8" rx="3" fill={fill(u + "b", "#A85410")} stroke="#7A3A00" strokeWidth="2.5" />
            <rect x="25" y="50.5" width="14" height="3.5" rx="1.2" fill="#FFD43B" />
            <polygon points="32,13.5 34,18 39,18.5 35.3,21.6 36.5,26.5 32,23.8 27.5,26.5 28.7,21.6 25,18.5 30,18" fill="#FFF7CC" />
            <path d="M21.5 12h4v8.5c0 4.2 1.2 7.8 3.2 10.6-4.4-1.9-7.2-6.2-7.2-11.3z" fill="#FFFFFF" opacity=".6" />
        </>
    ),

    tv: (u) => (
        <>
            <defs>
                {grad(u + "b", "#4A63D8", "#1B2A86", 9, 46)}
                {grad(u + "s", "#9AF3FF", "#1C9FE6", 14, 41)}
                {grad(u + "p", "#FFC15A", "#F0670F", 19, 36)}
                <g id={u + "x"}>
                    <rect x="19" y="1" width="3.5" height="11" rx="1.75" transform="rotate(-30 20.75 6.5)" />
                    <rect x="41.5" y="1" width="3.5" height="11" rx="1.75" transform="rotate(30 43.25 6.5)" />
                    <circle cx="18" cy="2" r="2.8" />
                    <circle cx="46" cy="2" r="2.8" />
                    <rect x="5" y="9" width="54" height="37" rx="7" />
                    <path d="M26 45h12l2.5 7h-17z" />
                    <rect x="16" y="51" width="32" height="6" rx="3" />
                </g>
            </defs>
            {outline(u + "x", "#0A1240")}
            <rect x="19" y="1" width="3.5" height="11" rx="1.75" transform="rotate(-30 20.75 6.5)" fill="#2B3CA8" />
            <rect x="41.5" y="1" width="3.5" height="11" rx="1.75" transform="rotate(30 43.25 6.5)" fill="#2B3CA8" />
            <circle cx="18" cy="2" r="2.8" fill="#FFB13B" />
            <circle cx="46" cy="2" r="2.8" fill="#FFB13B" />
            <path d="M26 45h12l2.5 7h-17z" fill="#1B2A86" />
            <rect x="16" y="51" width="32" height="6" rx="3" fill="#2B3CA8" />
            <rect x="5" y="9" width="54" height="37" rx="7" fill={fill(u + "b", "#2B3CA8")} />
            <rect x="10" y="14" width="44" height="27" rx="4.5" fill={fill(u + "s", "#4CC6F2")} stroke="#0A1240" strokeWidth="2" />
            <path d="M15 16h12l-9.5 23H14a2 2 0 0 1-2-2V19a3 3 0 0 1 3-3z" fill="#FFFFFF" opacity=".35" />
            <circle cx="32" cy="27.5" r="8.5" fill={fill(u + "p", "#F58A1F")} stroke="#6A2A00" strokeWidth="2" />
            <path d="M29.5 23.2l7.5 4.3-7.5 4.3z" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M10.5 12.5h9" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" opacity=".55" />
        </>
    ),

    team: (u) => (
        <>
            <defs>
                {grad(u + "c", "#9FF7EF", "#14A5C4", 12, 46)}
                {grad(u + "b", "#78C8FF", "#1260E6", 12, 46)}
                {grad(u + "o", "#FFC864", "#F0640C", 15, 57)}
                <g id={u + "x"}>
                    <circle cx="17" cy="20" r="7.5" />
                    <path d="M4 46c0-8.8 5.8-14.5 13-14.5S30 37.2 30 46z" />
                    <circle cx="47" cy="20" r="7.5" />
                    <path d="M34 46c0-8.8 5.8-14.5 13-14.5S60 37.2 60 46z" />
                    <circle cx="32" cy="25" r="9.5" />
                    <path d="M14 57c0-11 8-18 18-18s18 7 18 18z" />
                </g>
            </defs>
            {outline(u + "x", "#0A1F5C")}
            <g stroke="#0A1F5C" strokeWidth="3" strokeLinejoin="round">
                <path d="M4 46c0-8.8 5.8-14.5 13-14.5S30 37.2 30 46z" fill={fill(u + "c", "#4CC9DA")} />
                <circle cx="17" cy="20" r="7.5" fill={fill(u + "c", "#4CC9DA")} />
                <path d="M34 46c0-8.8 5.8-14.5 13-14.5S60 37.2 60 46z" fill={fill(u + "b", "#3D93F2")} />
                <circle cx="47" cy="20" r="7.5" fill={fill(u + "b", "#3D93F2")} />
            </g>
            <g stroke="#0A1F5C" strokeWidth="4" strokeLinejoin="round">
                <path d="M14 57c0-11 8-18 18-18s18 7 18 18z" fill={fill(u + "o", "#F58A1F")} />
                <circle cx="32" cy="25" r="9.5" fill={fill(u + "o", "#F58A1F")} />
            </g>
            <ellipse cx="14.5" cy="17" rx="2.6" ry="1.6" transform="rotate(-30 14.5 17)" fill="#FFFFFF" opacity=".65" />
            <ellipse cx="44.5" cy="17" rx="2.6" ry="1.6" transform="rotate(-30 44.5 17)" fill="#FFFFFF" opacity=".65" />
            <ellipse cx="28.5" cy="21" rx="3.2" ry="2" transform="rotate(-30 28.5 21)" fill="#FFFFFF" opacity=".7" />
            <path d="M20.5 52c.6-4 2.6-7.4 5.6-9.4" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity=".55" />
        </>
    ),

    cards: (u) => (
        <>
            <defs>
                {grad(u + "p", "#FF8DB5", "#E0115C")}
                {grad(u + "w", "#FFFFFF", "#D6E3FF")}
                <g id={u + "x"}>
                    <rect x="7" y="13" width="30" height="40" rx="5" transform="rotate(-12 22 33)" />
                    <rect x="23" y="9" width="31" height="42" rx="5" transform="rotate(8 38 30)" />
                    <path d={PENCIL} />
                </g>
            </defs>
            {outline(u + "x", "#2A1150")}
            <g transform="rotate(-12 22 33)">
                <rect x="7" y="13" width="30" height="40" rx="5" fill={fill(u + "p", "#F0407F")} stroke="#2A1150" strokeWidth="3" />
                <rect x="12" y="19" width="14" height="3.5" rx="1.75" fill="#FFFFFF" opacity=".7" />
            </g>
            <g transform="rotate(8 38 30)">
                <rect x="23" y="9" width="31" height="42" rx="5" fill={fill(u + "w", "#EEF3FF")} stroke="#2A1150" strokeWidth="3" />
                <rect x="28" y="15" width="17" height="5" rx="2.5" fill="#E0115C" />
                <rect x="28" y="24" width="21" height="3.4" rx="1.7" fill="#9EB0DD" />
                <rect x="28" y="30.5" width="15" height="3.4" rx="1.7" fill="#9EB0DD" />
            </g>
            <path d={PENCIL} fill="#2A1150" stroke="#2A1150" strokeWidth="4" strokeLinejoin="round" />
            <path d="M29.9 53.2L48.3 34.8L41.2 27.7L22.8 46.1Z" fill="#FFC21A" />
            <path d="M25.2 48.4L43.6 30" stroke="#FFF0A0" strokeWidth="2.2" strokeLinecap="round" opacity=".9" />
            <path d="M20 56L29.9 53.2L22.8 46.1Z" fill="#F7D9AE" />
            <path d="M20 56L23.4 55L21 52.6Z" fill="#3A2A50" />
            <path d="M48.3 34.8L51.1 32L44 24.9L41.2 27.7Z" fill="#CBD5E8" />
            <path d="M51.1 32L56.1 27L49 19.9L44 24.9Z" fill="#FF7AA8" />
            <path d="M29.9 53.2L22.8 46.1M48.3 34.8L41.2 27.7M51.1 32L44 24.9" stroke="#2A1150" strokeWidth="1.5" />
        </>
    ),

    buzzer: (u) => (
        <>
            <defs>
                {grad(u + "b", "#6A75A0", "#222740", 38, 55)}
                {grad(u + "r", "#FF6464", "#B00000", 20, 42)}
                <g id={u + "x"}>
                    <rect x="6" y="38" width="52" height="17" rx="8.5" />
                    <path d="M12 42c0-12.7 9-22 20-22s20 9.3 20 22z" />
                </g>
            </defs>
            {outline(u + "x", "#200818")}
            <rect x="6" y="38" width="52" height="17" rx="8.5" fill={fill(u + "b", "#3D4568")} />
            <rect x="10" y="40.5" width="44" height="4" rx="2" fill="#8E99C6" opacity=".7" />
            <path d="M12 42c0-12.7 9-22 20-22s20 9.3 20 22z" fill={fill(u + "r", "#D61A1A")} />
            <path d="M12 42h40" stroke="#200818" strokeWidth="2.5" strokeLinecap="round" />
            <ellipse cx="24.5" cy="28.5" rx="6.5" ry="3.4" transform="rotate(-30 24.5 28.5)" fill="#FFFFFF" opacity=".62" />
            <ellipse cx="42" cy="37" rx="3" ry="1.5" transform="rotate(-30 42 37)" fill="#FFFFFF" opacity=".35" />
        </>
    ),

    gear: (u) => (
        <>
            <defs>
                {grad(u + "g", "#FFFFFF", "#9AA6C2", 5, 59)}
                {grad(u + "h", "#4A63D8", "#1B2A86", 23, 41)}
                <g id={u + "x"}>
                    <circle cx="32" cy="32" r="19" />
                    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
                        <rect key={a} x="27" y="5" width="10" height="13" rx="2.5" transform={`rotate(${a} 32 32)`} />
                    ))}
                </g>
            </defs>
            {outline(u + "x", "#283350")}
            <use href={"#" + u + "x"} fill={fill(u + "g", "#C9D2E6")} />
            <circle cx="32" cy="32" r="13" fill="none" stroke="#283350" strokeWidth="2" opacity=".25" />
            <circle cx="32" cy="32" r="8.5" fill={fill(u + "h", "#2B3CA8")} stroke="#283350" strokeWidth="3" />
            <ellipse cx="29.5" cy="29" rx="2.4" ry="1.4" fill="#FFFFFF" opacity=".7" />
            <path d="M19.5 22a15 15 0 0 1 8-6.5" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" fill="none" opacity=".85" />
        </>
    ),

    buoy: (u) => (
        <>
            <defs>
                {grad(u + "w", "#FFFFFF", "#D5DEF0", 6, 58)}
                {grad(u + "r", "#FF5A6A", "#C0001A", 6, 58)}
                <path id={u + "x"} fillRule="evenodd" d="M32 6a26 26 0 1 0 0 52a26 26 0 1 0 0-52zM32 19a13 13 0 1 1 0 26a13 13 0 1 1 0-26z" />
            </defs>
            {outline(u + "x", "#4A0010")}
            <use href={"#" + u + "x"} fill={fill(u + "w", "#F3F6FF")} />
            <circle cx="32" cy="32" r="19.5" fill="none" stroke={fill(u + "r", "#E8122E")} strokeWidth="13" strokeDasharray="15.31 15.31" transform="rotate(-11 32 32)" />
            <path d="M13.5 24a20 20 0 0 1 9.5-10.5" stroke="#FFFFFF" strokeWidth="3.5" strokeLinecap="round" fill="none" opacity=".7" />
        </>
    ),

    book: (u) => (
        <>
            <defs>
                {grad(u + "c", "#FFB347", "#E8590C", 14, 56)}
                {grad(u + "p", "#FFFFFF", "#DDE6FA", 13, 52)}
                <g id={u + "x"}>
                    <path d={BOOK_COVER} /><path d={BOOK_L} /><path d={BOOK_R} />
                </g>
            </defs>
            {outline(u + "x", "#3A1A00")}
            <path d={BOOK_COVER} fill={fill(u + "c", "#F58A1F")} />
            <path d={BOOK_L} fill={fill(u + "p", "#F0F4FF")} stroke="#3A1A00" strokeWidth="2" strokeLinejoin="round" />
            <path d={BOOK_R} fill={fill(u + "p", "#F0F4FF")} stroke="#3A1A00" strokeWidth="2" strokeLinejoin="round" />
            <path d="M12.5 23c5-1.3 10-1 15 1M12.5 29c5-1.3 10-1 15 1M12.5 35c5-1.3 10-1 15 1M12.5 41c5-1.3 10-1 15 1" stroke="#9EB0DD" strokeWidth="2.4" strokeLinecap="round" fill="none" />
            <path d="M37 29c5-2.3 10-2.3 14.5-1M37 35c5-2.3 10-2.3 14.5-1M37 41c5-2.3 10-2.3 14.5-1" stroke="#9EB0DD" strokeWidth="2.4" strokeLinecap="round" fill="none" />
            <path d="M43 15.6V28l3.5-3 3.5 3V14.4" fill="#E8122E" stroke="#3A1A00" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="M11 18.5c3-.9 6-1.2 9-1" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" fill="none" opacity=".9" />
        </>
    ),

    warn: (u) => (
        <>
            <defs>
                {grad(u + "g", "#FFE36E", "#F5A000", 8, 54)}
                <path id={u + "x"} d="M32 7L59 54H5z" />
            </defs>
            {outline(u + "x", "#5A2A00", 9)}
            <use href={"#" + u + "x"} fill={fill(u + "g", "#FFC21A")} stroke="#FBBF1A" strokeWidth="3" strokeLinejoin="round" />
            <rect x="29" y="21" width="6" height="19" rx="3" fill="#3A1A00" />
            <circle cx="32" cy="46.5" r="3.4" fill="#3A1A00" />
            <path d="M24 25l5.5-9.5" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" opacity=".65" />
        </>
    ),

    trash: (u) => (
        <>
            <defs>
                {grad(u + "g", "#FFFFFF", "#C8D5F2", 6, 57)}
                <g id={u + "x"}>
                    <rect x="25" y="6" width="14" height="8" rx="3" />
                    <rect x="10" y="12" width="44" height="9" rx="3.5" />
                    <path d={TRASH_BODY} />
                </g>
            </defs>
            {outline(u + "x", "#0A2A7A")}
            <rect x="25" y="6" width="14" height="8" rx="3" fill="#C8D5F2" />
            <rect x="29" y="9" width="6" height="3" rx="1.5" fill="#0A2A7A" />
            <path d={TRASH_BODY} fill={fill(u + "g", "#E6EDFB")} />
            <rect x="10" y="12" width="44" height="9" rx="3.5" fill={fill(u + "g", "#E6EDFB")} stroke="#0A2A7A" strokeWidth="2.5" />
            <path d="M25 28v21M32 28v21M39 28v21" stroke="#7A8DBA" strokeWidth="3" strokeLinecap="round" />
            <path d="M15 15.5h12" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" opacity=".9" />
        </>
    ),

    bulb: (u) => (
        <>
            <defs>
                {grad(u + "g", "#FFF7B0", "#FFC000", 8, 44)}
                {grad(u + "m", "#EEF2FA", "#8E99B8", 42, 55)}
                <g id={u + "x"}>
                    <circle cx="32" cy="25" r="17" />
                    <rect x="24" y="34" width="16" height="10" rx="2" />
                    <rect x="23" y="42" width="18" height="13" rx="4" />
                    <rect x="27" y="53" width="10" height="5" rx="2.5" />
                </g>
            </defs>
            {outline(u + "x", "#6A3A00")}
            <rect x="27" y="53" width="10" height="5" rx="2.5" fill="#3A4260" />
            <circle cx="32" cy="25" r="17" fill={fill(u + "g", "#FFD84D")} />
            <rect x="24" y="34" width="16" height="10" rx="2" fill={fill(u + "g", "#FFD84D")} />
            <rect x="23" y="42" width="18" height="13" rx="4" fill={fill(u + "m", "#BCC5DA")} stroke="#6A3A00" strokeWidth="2" />
            <path d="M24 46.5h16M24 50.5h16" stroke="#5B6687" strokeWidth="2" />
            <path d="M26.5 32l2.5-4.5 3 4.5 3-4.5 2.5 4.5" stroke="#E07B00" strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round" fill="none" />
            <ellipse cx="25.5" cy="18.5" rx="5" ry="3" transform="rotate(-35 25.5 18.5)" fill="#FFFFFF" opacity=".75" />
        </>
    ),

    timer: (u) => (
        <>
            <defs>
                {grad(u + "c", "#8FF3EA", "#1497BF", 15, 57)}
                {grad(u + "f", "#FFFFFF", "#E2EEFF", 20, 52)}
                {grad(u + "r", "#FF6464", "#B00000", 5, 19)}
                <g id={u + "x"}>
                    <circle cx="32" cy="36" r="21" />
                    <rect x="26.5" y="5" width="11" height="7" rx="2.5" />
                    <rect x="29" y="11" width="6" height="6" />
                    <rect x="48" y="12" width="8" height="7" rx="2.5" transform="rotate(40 52 15.5)" />
                </g>
            </defs>
            {outline(u + "x", "#0A2A5C")}
            <rect x="29" y="11" width="6" height="6" fill="#8E99B8" />
            <rect x="26.5" y="5" width="11" height="7" rx="2.5" fill={fill(u + "r", "#D61A1A")} />
            <rect x="48" y="12" width="8" height="7" rx="2.5" transform="rotate(40 52 15.5)" fill={fill(u + "r", "#D61A1A")} />
            <circle cx="32" cy="36" r="21" fill={fill(u + "c", "#3FC3D6")} />
            <circle cx="32" cy="36" r="15.5" fill={fill(u + "f", "#F2F7FF")} stroke="#0A2A5C" strokeWidth="2" />
            <path d="M32 36V20.5A15.5 15.5 0 0 1 46.4 30.2Z" fill="#FF7A8E" opacity=".85" />
            <path d="M32 22.5v3M45.5 36h-3M32 49.5v-3M18.5 36h3" stroke="#0A2A5C" strokeWidth="2" strokeLinecap="round" />
            <path d="M32 36L41 29" stroke="#0A2A5C" strokeWidth="3" strokeLinecap="round" />
            <circle cx="32" cy="36" r="2.6" fill="#0A2A5C" />
            <path d="M16.5 27a17 17 0 0 1 8-8" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" fill="none" opacity=".75" />
        </>
    ),

    skip: (u) => (
        <>
            <defs>
                {grad(u + "g", "#FFD84D", "#F0640C", 15, 49)}
                <g id={u + "x"}>
                    <path d="M7 15l22 17L7 49z" />
                    <path d="M30 15l22 17-22 17z" />
                </g>
            </defs>
            {outline(u + "x", "#6A2A00", 8)}
            <use href={"#" + u + "x"} fill={fill(u + "g", "#F8A020")} stroke="#F8A020" strokeWidth="2" strokeLinejoin="round" />
            <path d="M12 22.5l8 6M35 22.5l8 6" stroke="#FFFFFF" strokeWidth="2.6" strokeLinecap="round" opacity=".7" />
        </>
    ),
};

const Icona = ({ kind, size = 48, className = "", style }) => {
    //id univoco per istanza: evita conflitti tra i gradienti di icone uguali
    const uid = "ic" + useId().replace(/[^a-zA-Z0-9]/g, "");
    const draw = ICONS[kind];
    if (!draw) {
        return null;
    }

    return (
        <svg
            className={"icona " + className}
            width={size}
            height={size}
            viewBox="0 0 64 64"
            style={{ overflow: "visible", flexShrink: 0, ...style }}
            aria-hidden="true"
        >
            {draw(uid)}
        </svg>
    );
}

export default Icona;
